// extracted by mini-css-extract-plugin
module.exports = {"ConfirmationModal":"PendingEventDetailModal_ConfirmationModal__2JRdz"};